export const env = {
    environment: "dev",
    // environment : "big_academy",
  };
  